module.exports = __webpack_public_path__ + "static/img/WarmPlate (11).e9c4d40a.png";